/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs */

const en_job_form_enum_natural_sciences_and_mathematics29 = /** @type {(inputs: Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Sciences and Mathematics`)
};

const de_job_form_enum_natural_sciences_and_mathematics29 = /** @type {(inputs: Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturwissenschaften und Mathematik`)
};

/**
* | output |
* | --- |
* | "Natural Sciences and Mathematics" |
*
* @param {Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_natural_sciences_and_mathematics29 = /** @type {((inputs?: Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Natural_Sciences_And_Mathematics29Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_natural_sciences_and_mathematics29(inputs)
	return en_job_form_enum_natural_sciences_and_mathematics29(inputs)
});
export { job_form_enum_natural_sciences_and_mathematics29 as "job_form_enum_NATURAL_SCIENCES_AND_MATHEMATICS" }